module.exports = __webpack_public_path__ + "static/media/internet-explorer.c11622af.svg";